import { ROUTES } from 'routers/Routes'
import { DocumentSummary } from './types'

export const documentPath = (doc: Pick<DocumentSummary, 'id'> | number) =>
  ROUTES.DOCUMENT_DETAIL.replace(
    ':id',
    String(typeof doc === 'number' ? doc : doc.id)
  )

/** What the review page needs to step through the list it was opened from. */
export type DocumentNavState = { ids?: number[]; from?: string } | null

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
